<template>
    <div>
        <div class="d-flex justify-space-between align-center">
			<v-tabs
				v-model="tabs"
				center-active
				active-class="mid-primary"
				color="white"
            >
                <v-tab :to="{ name: 'add-job-position' }">
					<v-icon class="me-1"> mdi-briefcase-account-outline </v-icon>
					{{ $T('Settings.tabs.jobPosition') }}
				</v-tab>

                <v-tab :to="{ name: 'add-languages' }">
					<v-icon class="me-1"> mdi-briefcase-account </v-icon>
					{{ $T('Settings.tabs.AddLanguages') }}
				</v-tab>

                <v-tab :to="{ name: 'add-computer-skills' }">
					<v-icon class="me-1"> mdi-account </v-icon>
					{{ $T('Settings.tabs.AddComputerSkills') }}
				</v-tab>

                <v-tab :to="{ name: 'add-details-type' }">
					<v-icon class="me-1"> mdi-account </v-icon>
					{{ $T('Settings.tabs.AddDetailsType') }}
				</v-tab>
            </v-tabs>
        </div>

        <v-divider></v-divider>

        <router-view></router-view>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tabs: 0
        }
    }
}
</script>
